import React from 'react';
import PlatformChips from '../PlatformChips';

// Song / album chart rankings across platforms.

function RankRow({ it, group }) {
  const chart = it.chart || {};
  const obj = group === 'songRanks' ? it.song : it.album;
  const title = obj ? obj.name || '—' : '—';
  const pos = it.position;
  const toc = it.timeOnChart != null ? `${it.timeOnChart} ${it.timeOnChartUnit || ''}` : '—';
  return (
    <tr>
      <td><span className={pos === 1 ? 'ss-pos ss-pos-top' : 'ss-pos'}>#{pos}</span></td>
      <td><div className="ss-rank-cell">{obj && obj.imageUrl && <img className="ss-thumb" src={obj.imageUrl} alt="" loading="lazy" />}<span className="ss-rank-name">{title}</span></div></td>
      <td className="ss-td-dim">{chart.name || '—'}</td>
      <td className="ss-td-dim">#{it.peakPosition != null ? it.peakPosition : '—'}</td>
      <td className="ss-td-dim">{toc}</td>
    </tr>
  );
}

function RankTable({ rows, group }) {
  return (
    <div className="ss-card">
      <div className="ss-table-wrap">
        <table className="ss-table">
          <thead><tr><th>Pos</th><th>{group === 'songRanks' ? 'Song' : 'Album'}</th><th>Chart</th><th>Peak</th><th>On chart</th></tr></thead>
          <tbody>
            {rows.length ? rows : <tr><td colSpan={5} className="ss-td-dim">No entries</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default function RanksGroup({ group, platforms, entries, chipIdx, setChipIdx }) {
  const title = group === 'songRanks' ? 'Song Charts' : 'Album Charts';

  let rows;
  if (chipIdx === 0) {
    const all = [];
    platforms.forEach(e => (e.items || []).forEach(it => all.push(it)));
    all.sort((a, b) => (a.position || 9999) - (b.position || 9999));
    rows = all.slice(0, 100).map((it, i) => <RankRow key={i} it={it} group={group} />);
  } else {
    const entry = entries[chipIdx];
    const items = entry ? entry.items.slice().sort((a, b) => (a.position || 9999) - (b.position || 9999)).slice(0, 50) : [];
    rows = items.map((it, i) => <RankRow key={i} it={it} group={group} />);
  }

  return (
    <>
      <div className="ss-content-title"><h2>{title}</h2><span className="ss-sec-hint">Chart positions across platforms</span></div>
      <PlatformChips entries={entries} idx={chipIdx} onPick={setChipIdx} />
      <RankTable rows={rows} group={group} />
    </>
  );
}
